
import { Component, Mixins } from "vue-property-decorator";
import {
  DocumentAttributes,
} from "../../../../domain/document";
import { Department } from "../../../../domain/department";
import { Patient } from "../../../../domain/patient";
import { EditingDocument } from "..";

@Component({
})
export default class DocumentAttributesEditableMixin extends Mixins() {
  editingSource: EditingDocument;
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  get attributes(): DocumentAttributes {
    return this.readPropertyOrDefault(s => s.source.attributes, null);
  }

  set attributes(source: DocumentAttributes) {
    this.writePropertyWhenValid(s => s.source.attributes = source);
  }

  get patientAttribute(): Patient {
    return this.readPropertyOrDefault(s => s.attributes.patient, null);
  }

  get departmentAttribute(): Department {
    return this.readPropertyOrDefault(s => s.attributes.department, null);
  }

  get departmentAttributeWithUndefined(): Department {
    return this.readPropertyOrDefault(s => s.attributes.department ? s.attributes.department : null, undefined);
  }

  get formatOriginalId(): number {
    return this.readPropertyOrDefault(s => s.attributes.format.originalId, -1);
  }
}
